import { API_BASE_URL } from "src/config/apiBase";
import React, { useEffect, useState } from 'react';
import { downloadSpreadsheet } from '../../utils/excelSheet';
import { useSidebar } from '../../SidebarContext';
import Header from '../Header';
import Sidebar from '../SideBar';
import '../../CSS/Global.css';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import { useNavigate } from 'react-router-dom';
import { decryptToken } from '../utils/getToken';

const Export = () => {

    const [isSpecificDateSelected, setIsSpecificDateSelected] = useState(false);
    const [fileFormat, setFileFormat] = useState("xlsx");
    const [password, setPassword] = useState("");
    const [invoiceData, setInvoiceData] = useState([]);
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const url = API_BASE_URL
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const navigate = useNavigate()
    const token = decryptToken("accessToken") || ""

    useEffect(() => {
        fetch(`${url}/newinvoice/all/${isLoggedIn.main_id}`, {
            method: "GET",
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
            .then(res => res.json())
            .then(data => {
                console.log("Fetched Invoice Data:", data);
                const list = Array.isArray(data) ? data : data.data || [];
                setInvoiceData(list);
            })
            .catch(err => console.error("Failed to fetch invoices:", err));
    }, []);


    const handleRadioChange = (e) => {
        setIsSpecificDateSelected(e.target.value === 'specificDate');
    };

    // const handleExport = () => {
    //     if (!fileFormat) return alert("Please select a file format.");
    //     // if (!password) return alert("Please enter a file password.");
    //     if (invoiceData.length === 0) return alert("No invoice data found.");

    //     let filteredData = [...invoiceData];

    //     if (isSpecificDateSelected) {
    //         if (!startDate || !endDate) return alert("Please select both start and end dates.");

    //         filteredData = invoiceData.filter(inv => {
    //             const invoiceDate = new Date(inv.invoice_date);
    //             const start = new Date(startDate);
    //             const end = new Date(endDate);
    //             return invoiceDate >= start && invoiceDate <= end;
    //         });

    //         if (filteredData.length === 0) {
    //             return alert("No invoices found in the selected date range.");
    //         }
    //     }

    //     // const cleanedData = filteredData.map(inv => ({
    //     //     "Invoice Date": inv.invoice_date,
    //     //     "Order Number": inv.order_number,
    //     //     "Customer Name": inv.customer_name,
    //     //     "Due Date": inv.due_date,
    //     //     "Grand Total": inv.grand_total,
    //     //     "Pending": inv.pending,
    //     //     "Status": inv.pending === 0
    //     //         ? "Paid"
    //     //         : inv.due_date < new Date().toISOString().split("T")[0]
    //     //             ? "Overdue"
    //     //             : "Pending"
    //     // }));

    //     const cleanedData = filteredData.flatMap(inv => {
    //         let parsedItems = [];
    //         try {
    //             parsedItems = JSON.parse(inv.items);
    //         } catch (err) {
    //             console.warn(`Failed to parse items for invoice ${inv.invoice_number}`);
    //         }

    //         const rows = [];
    //         const formatDate = (dateStr) => {
    //             const date = new Date(dateStr);
    //             return isNaN(date) ? "" : date.toISOString().split("T")[0];
    //         };

    //         // Convert invoice_date and due_date to Excel-compatible format (e.g., 'YYYY-MM-DD')
    //         const invoiceDate = formatDate(inv.invoice_date);
    //         const dueDate = formatDate(inv.due_date);

    //         // If no items, return one row with empty item fields
    //         if (!Array.isArray(parsedItems) || parsedItems.length === 0) {
    //             rows.push({
    //                 "invoice_date": invoiceDate,
    //                 "customer_name": inv.customer_name,
    //                 "due_date": dueDate,
    //                 "Items": "",
    //                 "Quantity": "",
    //                 "Rate": "",
    //                 "Discount": "",
    //                 "Tax": "",
    //                 "Advance Payment": inv.advance_payment || 0,
    //                 "Service Fees/Shipping": inv.shipping || 0,
    //                 "Customer Note": inv.customer_note || "",
    //                 "Customer ID": inv.customer_id || "",
    //                 "Sales Person ID": inv.sales_person_id || "",
    //                 "Sales Person Name": inv.sales_person_name || ""
    //             });
    //         } else {
    //             const items = parsedItems;
    //             const itemTitles = items.map(i => i.item).join(",");
    //             const quantities = items.map(i => i.quantity).join(",");
    //             const rates = items.map(i => i.rate).join(",");
    //             const discounts = items.map(i => i.discount).join(",");
    //             const taxes = items.map(i => i.tax).join(",");

    //             rows.push({
    //                 "invoice_date": invoiceDate,
    //                 "customer_name": inv.customer_name,
    //                 "due_date": dueDate,
    //                 "Items": itemTitles,
    //                 "Quantity": quantities,
    //                 "Rate": rates,
    //                 "Discount": discounts,
    //                 "Tax": taxes,
    //                 "Advance Payment": inv.advance_payment || 0,
    //                 "Service Fees/Shipping": inv.shipping || 0,
    //                 "Customer Note": inv.customer_note || "",
    //                 "Customer ID": inv.customer_id || "",
    //                 "Sales Person ID": inv.sales_person_id || "",
    //                 "Sales Person Name": inv.sales_person_name || ""
    //             });
    //         }

    //         return rows;
    //     });



    //     const worksheet = XLSX.utils.json_to_sheet(cleanedData);
    //     const workbook = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(workbook, worksheet, "Invoices");

    //     const fileName = `invoices_${new Date().getTime()}.${fileFormat}`;
    //     XLSX.writeFile(workbook, fileName); // 👈 downloads directly (no zip)
    // };

    const handleExport = async () => {
        if (!fileFormat) return alert("Please select a file format.");
        if (invoiceData.length === 0) return alert("No invoice data found.");

        let filteredData = [...invoiceData];

        if (isSpecificDateSelected) {
            if (!startDate || !endDate) return alert("Please select both start and end dates.");

            filteredData = invoiceData.filter(inv => {
                const invoiceDate = new Date(inv.invoice_date);
                const start = new Date(startDate);
                const end = new Date(endDate);
                return invoiceDate >= start && invoiceDate <= end;
            });

            if (filteredData.length === 0) {
                return alert("No invoices found in the selected date range.");
            }
        }

        const cleanedData = filteredData.map(inv => {
            let parsedItems = [];
            try {
                parsedItems = JSON.parse(inv.items);
            } catch (err) {
                console.warn(`Failed to parse items for invoice ${inv.invoice_number}`);
            }

            const formatDate = (dateStr) => {
                const date = new Date(dateStr);
                return isNaN(date) ? "" : date.toISOString().split("T")[0];
            };

            const invoiceDate = formatDate(inv.invoice_date);
            const dueDate = formatDate(inv.due_date);

            const items = Array.isArray(parsedItems) ? parsedItems : [];

            const itemTitles = items.map(i => i.item?.title || "").join(",");
            const quantities = items.map(i => i.quantity || "").join(",");
            const rates = items.map(i => i.rate || "").join(",");
            const discounts = items.map(i => i.discount || "").join(",");
            const taxes = items.map(i => i.tax || "").join(",");

            return {
                "invoice_date": invoiceDate,
                "customer_name": inv.customer_name || "",
                "Customer ID": inv.customer_id || "",
                "Order Number": inv.order_number || "",
                "invoice_number": inv.invoice_number || "",
                "due_date": dueDate,
                "Items": itemTitles,
                "Quantity": quantities,
                "Rate": rates,
                "Discount": discounts,
                "Tax": taxes,
                "Advance Payment": inv.advance_payment || 0,
                "Service Fees/Shipping": inv.shipping || 0,
                "Grand Total": inv.grand_total,
                "Customer Note": inv.customer_note || "",
                "Customer ID": inv.customer_id || "",
                // "Sales Person ID": inv.sales_person_id || "",
                // "Sales Person Name": inv.sales_person_name || ""
            };
        });

        const base = `invoices_${new Date().getTime()}`;
        await downloadSpreadsheet(cleanedData, "Invoices", base, fileFormat);
    };

    return (
        <>
            <div className="export-card">
                {/* Export Options */}
                <div className="export-radio">
                    <div className="export-radio-list">
                        <input type="radio" name="exportOption" value="allCustomers" checked={!isSpecificDateSelected} onChange={handleRadioChange} />
                        <label>All Customers</label>
                    </div>
                    <div className="export-radio-list">
                        <input type="radio" name="exportOption" value="specificDate" checked={isSpecificDateSelected} onChange={handleRadioChange} />
                        <label>Specific Date</label>
                    </div>
                </div>

                {isSpecificDateSelected && (
                    <div className="date-range">
                        <div className="date-range-list">
                            <label>Start Date:</label>
                            <input
                                type="date"
                                value={startDate}
                                onChange={(e) => setStartDate(e.target.value)}
                            />
                        </div>
                        <div className="date-range-list">
                            <label>End Date:</label>
                            <input
                                type="date"
                                value={endDate}
                                onChange={(e) => setEndDate(e.target.value)}
                            />
                        </div>
                    </div>

                )}

                {/* Format selection */}
                <div className="export-file-type">
                    <p className="export-file-header">Select file format:</p>
                    <div className="export-file-options">
                        {["csv", "xls", "xlsx"].map(fmt => (
                            <div className="export-file-option-list" key={fmt}>
                                <input type="radio" name="fileFormat" id={fmt} value={fmt} onChange={e => setFileFormat(e.target.value)} />
                                <label htmlFor={fmt}>{fmt.toUpperCase()}</label>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Password input */}
                {/* <div className="file-password">
                        <p className="file-password-header">File Password:</p>
                        <input type="password" placeholder="Enter password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div> */}

                {/* Export Buttons */}
                <div className="export-buttons">
                    <button className="export-button" type="button" onClick={handleExport}>Export</button>
                    <button className="export-cancel-button" type="button" onClick={() => navigate(-1)}>Cancel</button>
                </div>
            </div>
        </>
    );
};

export default Export;
